import { c as _c } from "react/compiler-runtime";
import dayjs from 'dayjs';
import React from 'react';
import IconArrow from '@/assets/icons/heroIcons/Arrow-right.svg';
import { Link, LinkProps } from '@/components/links';
import { Badge } from '@/components/Badge/Badge';
export type ArticleBoxProps = {
  name: string | React.JSX.Element;
  content: string | React.JSX.Element;
  date: string;
  link: LinkProps['to'];
  target?: LinkProps['target'];
  tag?: string | null;
};
export function ArticleBox(props) {
  const $ = _c(20);
  const t0 = props.target;
  const t1 = props.link;
  let t2;
  if ($[0] !== props.tag) {
    t2 = props.tag && <div className="mb-3 lg:absolute lg:-top-3 lg:right-8"><Badge title={props.tag} /></div>;
    $[0] = props.tag;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== props.name) {
    t3 = <strong className="mb-3 block text-base font-semibold text-white lg:mb-4 lg:text-xl">{props.name}</strong>;
    $[2] = props.name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props.content) {
    t4 = <p className="mb-9 line-clamp-5 text-sm text-white opacity-80 lg:mb-12 lg:text-base">{props.content}</p>;
    $[4] = props.content;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props.date) {
    t6 = dayjs(props.date).format("DD.MM.YYYY");
    $[9] = props.date;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <span className="text-xs text-white opacity-80">{t6}</span>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute right-0 bottom-0 flex h-12 w-12 items-center justify-center rounded-tl-2xl rounded-br-3xl bg-blue-700 text-white lg:h-14 lg:w-14"><IconArrow width={16} height={16} /></div>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== props.link || $[15] !== props.target || $[16] !== t2 || $[17] !== t5 || $[18] !== t7) {
    t9 = <Link target={t0} to={t1} testId="articleBox" analyticsParam="articleBox" className="relative flex flex-[1_1_0%] flex-col rounded-3xl bg-blue-800 px-5 py-6 no-underline transition hover:bg-blue-700 lg:justify-between lg:px-8 lg:pt-10 lg:pb-5">{t2}{t5}{t7}{t8}</Link>;
    $[14] = props.link;
    $[15] = props.target;
    $[16] = t2;
    $[17] = t5;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}